import { mapGetters, mapState, mapActions } from 'vuex'

export default {
    methods: {
        ...mapActions('stats', {
            _fetchHashtagStats: 'get',
        }),
        async getHashtagStats (hashtag) {
            const data = this._getHashtagStats(hashtag)
            if (data) {
                return data
            }
            await this._fetchHashtagStats(hashtag)
            return this._getHashtagStats(hashtag)
        }
    },
    computed: {
        ...mapGetters({
            _getHashtagStats: 'stats/get'
        }),
        ...mapState('stats', ['loading', 'error']),
    },
    created () {

    }
}
